

import React, { useState } from 'react';
import { ListGroup, Badge,Card, Tabs, Tab,  Form, Alert } from "react-bootstrap";
import {  MessageTranslation, Preview } from '../../api/types/messages';
import { Base64 } from 'js-base64';
import { usePreviewQuery } from '../../api/messageAPI';
import { LoaderComponent } from '../LoaderComponent';
import { LanguageCodeVariant } from '../../constants';

interface TranslationViewProps {
    height?: string;
    trans: MessageTranslation;
    preview: boolean;
} 

interface MessagePreviewProps {
    content: string;
    subject: string;
    height: string;
    language: string;
}

const contentViewer = (data:Preview, subject:string, height:string)=>{
    return <React.Fragment>
        {data.errors ? data.errors.map(err => <Alert variant='danger'>{err}</Alert>) : ''}
        <iframe srcDoc={data.content} title={subject} style={{ height: height, maxHeight: height, maxWidth:"95%", overflow:"auto", display:"flex", width:"95%" }} className="border m-1 p-1"/>
    </React.Fragment>
}

export const MessagePreview: React.FC<MessagePreviewProps> = (props) => {
    const {data, error, isLoading } = usePreviewQuery({'content': props.content, 'language': props.language});
    return <React.Fragment>
        <LoaderComponent isLoading={isLoading} error={error}/>
        {data ? contentViewer(data, props.subject, props.height) : ''}
    </React.Fragment>
}

export const TranslationView: React.FC<TranslationViewProps> = (props) => {
    const trans = props.trans;
    const data = Base64.decode(trans.templateDef);

    const [usePreview, setPreview] = useState<boolean>(props.preview);

    const height = props.height ?? '800px';

    return (
        <ListGroup.Item key={trans.lang}>
            <h5><Badge bg={LanguageCodeVariant} className="me-1">{trans.lang}</Badge>{trans.subject}</h5>
            <Tabs  defaultActiveKey="preview">
                <Tab eventKey="" title="Preview">
                    {props.preview ? <Form.Check  type="switch" label="Preview message with layout" defaultChecked={usePreview} onChange={e => setPreview(e.currentTarget.checked)}/> : ''}
                    { usePreview ? <MessagePreview content={data} subject={trans.subject} height={height} language={trans.lang}/> : contentViewer({'content': data}, trans.subject, height)}
                </Tab>
                 <Tab eventKey='code' title="Code">
                <textarea defaultValue={data}className='border m-1 p-1 w-100' readOnly={true}  style={{ height: height, maxHeight: height, maxWidth:"95%", overflow:"auto", display:"flex", width:"95%" }}>
                </textarea>
                </Tab>
            </Tabs>
        </ListGroup.Item>
    );
}

interface TranslationListProps {
    translations: MessageTranslation[];
    preview: boolean;
    height?: string;
} 

export const TranslationListView: React.FC<TranslationListProps> = (props) => {
    return <Card>
        <Card.Header>Translations</Card.Header>
        <ListGroup>
        { props.translations.map( (trans) => <TranslationView key={trans.lang} trans={trans} height={props.height} preview={props.preview}/> ) }
        </ListGroup>
    </Card>;
 }

